var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBag = function SvgBag(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none",
    viewBox: "0 0 8 8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    fillRule: "evenodd",
    d: "M4.046.667c.265 0 .462 0 .632.045.46.123.82.483.943.943.03.111.04.234.044.379.103.014.197.035.286.064a2 2 0 0 1 1.285 1.284c.046.142.07.297.083.48a1.333 1.333 0 0 1-1.214 1.134C6.055 5 5.995 5 5.833 5h-1.5v-.067a.333.333 0 1 0-.666 0V5h-1.5c-.161 0-.223 0-.272-.004A1.333 1.333 0 0 1 .681 3.862c.013-.183.037-.338.084-.48a2 2 0 0 1 1.284-1.284c.089-.03.183-.05.286-.064.004-.145.014-.268.044-.38.123-.46.482-.819.943-.942.17-.046.367-.046.632-.045h.092ZM3.003 2H4.997a.766.766 0 0 0-.02-.173.667.667 0 0 0-.471-.471c-.074-.02-.175-.023-.506-.023s-.432.003-.506.023a.667.667 0 0 0-.471.471.766.766 0 0 0-.02.173Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M3.667 5.733v-.066H2.15c-.139 0-.228 0-.307-.007a1.995 1.995 0 0 1-1.174-.5c.005.327.025.574.096.791a2 2 0 0 0 1.284 1.284c.302.098.662.098 1.218.098h1.466c.557 0 .916 0 1.218-.098a2 2 0 0 0 1.285-1.284c.07-.217.09-.464.095-.792a1.995 1.995 0 0 1-1.174.501 4.155 4.155 0 0 1-.307.007H4.333v.066a.333.333 0 1 1-.666 0Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBag);
export default ForwardRef;